export default __webpack_public_path__ + "static/main-dinosaur-390be3322736586cbe535b80b087ba44.jpg";